import { render, staticRenderFns } from "./MarketingCheckbox.vue?vue&type=template&id=275aa5b4"
import script from "./MarketingCheckbox.vue?vue&type=script&lang=js"
export * from "./MarketingCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports